import React from "react";
import { makeStyles } from "@mui/styles"; // Mise à jour pour utiliser le bon package
import Chip from "@mui/material/Chip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { IconButton } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    margin: "10px auto",
    // color: theme.palette.primary.main,
  },
  delete: {
    position: "absolute",
    marginTop: "-14px",
    marginLeft: "-6px",
  },
}));

export default function ItemsEnumerator(props) {
  const classes = useStyles();
  const {
    values,
    title,
    type,
    multipleChoice,
    canDelete,
    onChange,
    onDelete,
    onEdit,
  } = props;

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <span
          onClick={() => onEdit && onEdit(type)}
          style={{ cursor: onEdit ? "pointer" : "default" }}
        >
          {title}
        </span>
        {canDelete ? (
          <IconButton
            className={classes.delete}
            onClick={() => onDelete(type)}
            size="large"
          >
            <HighlightOffIcon />
          </IconButton>
        ) : null}
      </div>

      {(values || []).map((data, index) => {
        return (
          <Chip
            key={index}
            style={{ display: "inline-block", padding: "5px" }}
            label={data}
            // onDelete={data === "React" ? undefined : onChange(data)} // c'etait un exemple
          />
        );
      })}

      <input
        type="text"
        style={{ border: "none", outline: "none", margin: "0 8px" }}
        placeholder="Nouvelle valeur"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            const newValue = e.target.value;
            if (newValue) {
              if (!values.includes(newValue)) {
                onChange([...values, newValue], type, multipleChoice);
              }
              e.target.value = "";
            }
          }
        }}
      />
    </div>
  );
}
